
<div v-resize ="onResize">
    <drop
        class        = "cut"
        @drop        = "onDrop"
        mode         = "cut"
        accepts-type = "inb-message-selectable"
    >
    <v-container class="site-selected" :style="style" >
        <div class="v-label v-label--active theme--light primary--text mb-1" v-if="showTitle">
            Anlagen
        </div>
        <drag
            v-for    = "item in sites"
            :data    = "item"
            :key     = "item.id"
            @cut     = " onRemove(item)"
            type     = "inb-message"
        >
            <v-card
                flat
                rounded
                :class="cardstyle?'card-style':'list-style'"
                style="padding-right: 5px; "
            >
                <div >
                    <div class="v-flex" style="justify-content: space-between">
                        <div style="font-size: 14px">Fabrik-Nr. {{ item.fabricNo }}</div>
                        <div v-if="navigate"><a @click="onSite(item)"><i class="fa fa-arrow-left mr-2 primary--text"></i></a></div>
                    </div>
                    <div class="card-subtitle">{{ item.street }}, {{ item.zip }} {{ item.city }}</div>
                </div>
                <v-divider v-if="!cardstyle" class="mt-1 mb-0"/>
            </v-card>
        </drag>

        <div class="v-flex" :class="cardstyle?'mt-1 ml-3':'mt-0'" style="justify-content: space-between;">
            <v-menu
                v-if                    = "!readonly"
                v-model                 = "edit"
                min-width               = "450"
                max-width               = "450"
                transition              = "scale-transition"
                :close-on-content-click = "false"
                :close-on-click         = "false"
                :offset-x               = "true"
                :left                   = "cardstyle"
                :right                  = "!cardstyle"
                nudge-top="-20"
                absolute
            >
                <template v-slot:activator="{ on, attrs }">
                    <div class="v-flex">
                        <a
                            v-bind = "attrs"
                            v-on   = "on"
                            class  = "pt-1"
                        >
                            <i class="fas fa-plus"></i>
                        </a>
                        <span class="ml-2 mt-1 ">Anlagen hinzufügen</span>
                    </div>
                </template>

                <div class="site-selectable">
                    <div class="v-flex primary white--text" style="height: 35px; padding-top: 5px">
                        <v-spacer />
                        <a class="white--text"> <i class="mr-1" />Auswahl Anlagen</a>
                        <v-spacer />
                        <a class="fas fa-times white--text pr-3 pt-1" @click="onClose"></a>
                    </div>

                    <div class="v-flex">
                        <v-text-field
                            hide-details
                            class         = "mt-0 pt-5 mb-3"
                            @input        = "onInput"
                            @click:append ="fullsearch=!fullsearch"
                            :append-icon  = "fullsearch ? 'fas fa-search-plus' : 'fas fa-search'"
                            v-model       = "sitesearch"
                            :label        = "fullsearch ? 'Volltextsuche' : 'Fabrik-Nr.'"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                        />
                    </div>

                    <v-container class="site-seletable-content">
                        <drag
                            v-for="item in selectable"
                            @cut       = "onCut(item)"
                            :key       = "item.id"
                            :data      = "item"
                            type       = "inb-message-selectable"
                            @dragstart = "onDragStart"
                            @dragend   = "onDragEnd"
                        >
                            <div class="dragable-card">
                                <div class="v-flex primary--text" style="justify-content: space-between">
                                    <div>Fabrik-Nr. {{ item.fabricNo }} {{ item.customer.name }} </div>
                                </div>
                                <div class="card-subtitle ">{{ item.type ? item.type.name : '' }}</div>
                                <div class="card-subtitle">{{ item.street }}, {{ item.zip }} {{ item.city }}</div>
                                <div class="card-subtitle">
                                    {{ item.ve  ? item.ve  : '-/-' }},
                                    {{ item.ve2 ? item.ve2 : '-/-' }},
                                    {{ item.ve3 ? item.ve3 : '-/-' }}
                                </div>
                            </div>
                        </drag>
                    </v-container>
                </div>
            </v-menu>

            <drop
                v-if         = "!readonly"
                class        = "cut"
                @drop        = "onTrash"
                mode         = "cut"
                accepts-type = "inb-message"
            >
                <div class="trash">
                    <a
                        draggable="false"
                    ><i class="fas fa-trash-alt primary--text"></i></a>
                </div>
            </drop>
        </div>
    </v-container>
    </drop>
</div>
